var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocketx1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 13.12003,
    height: 11.6,
    viewBox: "0 0 13.12003 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path320"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath322"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path322"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path324"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path326"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath328"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path328"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path330"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path332"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath334"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path334"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath337"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4239,1636.5)",
    id: "path337"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath341"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4239,1636.5)",
    id: "path341"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc2",
    transform: "translate(-112.10667,-357.78667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path319",
    d: "m 2602,5862 v 26 l -2,-25 z m 0,26 -2,-25 v 24 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath320)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path321",
    d: "m 2600,5863 v 24 l -2,-24 z m 0,24 -2,-24 v 24 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path323",
    d: "m 2598,5863 v 24 l -2,-23 z m 0,24 -2,-23 v 22 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path325",
    d: "m 2596,5864 v 22 l -2,-20 z m 0,22 -2,-20 v 18 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path327",
    d: "m 2594,5866 v 18 l -2,-17 z m 0,18 -2,-17 v 16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path329",
    d: "m 2592,5867 v 16 l -1,-14 z m 0,16 -1,-14 v 12 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath330)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path331",
    d: "m 2591,5869 v 12 l -1,-9 z m 0,12 -1,-9 v 7 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path333",
    d: "m 2590,5872 v 7 -5 z m 0,7 v -5 2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path335",
    d: "m 2602,5913 v -76",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "m -37.5,0 c 0,-20.71068 16.78932,-37.5 37.5,-37.5 20.71068,0 37.5,16.78932 37.5,37.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,118.58667,358.26667)",
    clipPath: "url(#clipPath337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "m 2590,5875 h -54",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path339",
    d: "m 2555,5895 v -20 -20",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "m -12.5,0 c 0,-6.90356 5.59644,-12.5 12.5,-12.5 6.90356,0 12.5,5.59644 12.5,12.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,118.58667,358.26667)",
    clipPath: "url(#clipPath341)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketx1);
export default __webpack_public_path__ + "static/media/socketx1.3a13f0108018c110ae5a66676c7a1731.svg";
export { ForwardRef as ReactComponent };